module.exports = __webpack_public_path__ + "static/img/down1.795fb8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down1.png
// module id = kej2
// module chunks = 1